import IconLabelledItem from '../IconLabelledItem/IconLabelledItem';

interface TriggerTemplateActionProps {
  name: string;
}

const TriggerTemplateAction = ({ name }: TriggerTemplateActionProps) => {
  return <IconLabelledItem iconName='map-pin' label={`Notificar por e-mail, app e navegador o usuário: ${name}`} />;
};

export default TriggerTemplateAction;
